import { Link } from "react-router-dom";
import { useAccountData } from "../../hooks/useAccountData";
import { Button, Flex, Image, Text } from "@chakra-ui/react";
import { CaretRightLargeIcon } from "../icons/CaretRightLargeIcon";

interface ChannelBannerProps {
  channelKey: string;
  onClick?: () => void;
}
export function ChannelBanner({ channelKey, onClick }: ChannelBannerProps) {
  const accountData = useAccountData();
  const channels = accountData?.home_tab_channels;
  const activeChannel = channels?.find((channel) => channel.id === channelKey);
  const primaryStream = activeChannel?.streams.find(
    (stream) => stream.is_primary,
  );
  return (
    <Link to={`/channel/${primaryStream?.slug}`} onClick={onClick}>
      <Button
        p={2}
        height={12}
        width="full"
        borderRadius="8px"
        border="1px solid"
        borderColor="transparent.white.10"
        display="flex"
        justifyContent="space-between"
      >
        <Flex gap={4} height="full" width="full" alignItems="center">
          <Image
            src={activeChannel?.config[0]?.icon}
            aspectRatio={1}
            borderRadius="4px"
            height="full"
          />
          <Text
            fontSize="14px"
            fontWeight="700"
            lineHeight="150%"
            fontFamily="Roboto"
            color="neutral.200"
          >
            View {activeChannel?.display_name} channel
          </Text>
        </Flex>
        <CaretRightLargeIcon boxSize="24px" color="neutral.600" />
      </Button>
    </Link>
  );
}
